/**
 * IIFE Entry Point - Global API only
 * This file is used for the browser IIFE build to expose only the global API
 */

import globalAPI from './index';

// For IIFE builds, we want to expose the global API directly
export default globalAPI;

// Auto-expose to window (this will be the global KaigenticChat object)
if (typeof window !== 'undefined') {
  window.KaigenticChat = globalAPI;
}